import classNames from 'classnames';
import CampaignStatistic from './CampaignStatistic';
import type { CampaignStatisticsProps } from './Campaign.data';
import styles from './Campaign.module.scss';

export default function CampaignStatistics({
  items,
  label,
  animate = true,
  className,
}: CampaignStatisticsProps) {
  if (!items.length) return null;

  return (
    <section aria-label={label} className={classNames(styles.statistics, className)}>
      <ul className={styles.statisticsGrid}>
        {items.map((item) => (
          <li key={item.id} className={styles.statistic}>
            <CampaignStatistic item={item} animate={animate} />
          </li>
        ))}
      </ul>
    </section>
  );
}
